/** Whitelist properties with camelCased CSS property names */
export const responsiveCssProperties = [
  'background',
  'backgroundColor',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'display',
  'flex',
  'flexDirection',
  'flexWrap',
  'justifyContent',
  'alignItems',
  'alignSelf',
  'justifySelf',
  'margin',
  'marginTop',
  'marginLeft',
  'marginRight',
  'marginBottom',
  'padding',
  'paddingTop',
  'paddingLeft',
  'paddingRight',
  'paddingBottom',
  'width',
  'height',
  'maxWidth',
  'maxHeight',
  'minWidth',
  'minHeight',
  'gridTemplateColumns',
  'gridTemplateRows',
  'columnGap',
  'rowGap',
  'gap',
  'gridColumn',
  'gridRow',
];
